import React, { Component } from "react";
import { Helmet } from "react-helmet";

class About extends Component {
  componentDidMount() {
    document.getElementById("root").classList.remove("welcome");
    document.getElementById("foo").classList.add("overflow");
  }
  render() {
    return (
      <div className="sub-page">
        <Helmet>
          <title>STech - Terms &amp; Conditions</title>
          <meta
            name="description"
            content="STech - Terms &amp; Conditions pages"
          />
        </Helmet>
        <header className="clearfix fadeInUp">
          <div className="container">
            <div className="left" />
            <div className="right">
              <h1>Terms &amp; Conditions</h1>
              <h2>Version 1.0</h2>
            </div>
          </div>
        </header>
        <section className="clearfix terms fadeInUp">
          <div className="container">
            <div className="content">
              <h2>1. Our Terms and Conditions</h2>
              <p>
                STech Technology UK Limited is a company incorporated in England
                and Wales with company number 10897880 and whose registered
                address is at South Quay Building, 77 Marsh Wall, London, England, E14 9SH.
                (&ldquo;STech&rdquo; &ldquo;Company&rdquo;,
                &ldquo;we&rdquo;,&nbsp;&ldquo;us&rdquo;). STech is licensed by
                the&nbsp;Gambling Commission&nbsp;with&nbsp;licence number{" "}
                <a href="https://secure.gamblingcommission.gov.uk/PublicRegister/Search/Detail/51276">
                  000-051276-R-328757-001
                </a>
                .
              </p>
              <p>
                These Terms and Conditions govern your use of this website
                (&ldquo;Website&rdquo;). If you do not agree to any of these
                terms you should stop using the Website. These Terms and
                Conditions incorporate our Privacy Policy and Cookie Policy.
              </p>
              <p>
                The purpose of the Website is to present you with information
                about STech, and the services that we offer to our clients and
                partners.
              </p>
              <h2>2. Accuracy of information on the Website</h2>
              <p>
                STech makes reasonable efforts to ensure that information on the
                Website is accurate but content is provided for general,
                informational purposes only and is not to be relied by you.
              </p>
              <h2>3. Limitation on our liability</h2>
              <p>
                You agree that STech have no liability to you whatsoever in
                respect of any loss resulting from your access to and use of
                this Website, including any loss arising out of any mistake,
                error, inaccuracy or omission in the information contained on
                the Website save for our liability to you arising from fraud or
                fraudulent misrepresentation of any liability that we are
                precluded by law from excluding.
              </p>
              <h2>4. Our Intellectual property rights</h2>
              <p>
                STech are the owner or authorised licensee of all intellectual
                property rights existing on our Website. Our name, and the
                Website design, text, logo, source code, software and similar is
                copyrighted and subject to other proprietary rights and must not
                be copied, reproduced or used in any way without our express
                prior permission in writing. Your access to our Website and
                interest in our Services does not grant you any interest in any
                of our intellectual property rights, or the rights belonging to
                third parties which are used by us under licence. We reserve our
                rights in full to seek legal redress against any person who
                makes unlawful use of our intellectual property rights or those
                belonging to our licensees.{" "}
              </p>
              <p>
                In accessing our Website you undertake to not knowingly corrupt
                or attempt to corrupt the Website with a bug, malware, virus,
                DDS attack, and we reserve our rights to recover any losses
                incurred by us against you in full should you breach this
                undertaking.
              </p>
              <h2>5. Rights of third parties</h2>
              <p>
                No one other than you and us has any right to enforce any of
                these terms and conditions.
              </p>
              <h2>6. Variation</h2>
              <p>
                These Terms and Conditions may be varied by us at any time by
                displaying the new terms on this Website, and in continuing to
                use and access the Website you are deemed to accept such new
                terms.{" "}
              </p>
              <h2>7. Governing Law</h2>
              <p>
                These Terms and Conditions are governed by the laws of England
                and Wales and any disputes shall be resolved by the courts of
                England and Wales.{" "}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default About;
